<div class="ltms-description">{{ mainTabDescription }}</div>
<div class="filter">
    <button *ngIf="isQuestionGroupAvailable" [ngClass]="{'active': isQuestionGroupMode}" (mouseenter)="hover = true" (mouseleave)="hover = false" (click)="questionGroupClick()">
        <img [src]="hover || isQuestionGroupMode ? 'assets/images/folder-active.svg' : 'assets/images/folder.svg'">Group Questions
    </button>
    <div class="filter-title">View by</div>
    <app-score-dropdown-menu
        [config]="viewByDropdown.config"
        [selectedOption]="viewByDropdown.selectedOption"
        [options]="viewByDropdown.options"
        (selectedOptionChange)="onOptionChange($event)">
    </app-score-dropdown-menu>
    <span class="selected-option">{{ selectedOption }}</span>
    <div class="tab-comparison-right">
        <app-score-comparison-toggle
            [visible]="isComparisonAvailable"
            [showComparisonFlag]="showComparisonFlag"
            [dateType]="dateType"
            [checkboxId]="'scoreCustomComparisonCheckbox'"
            (showComparisonChange)="onShowComparisonChange($event)">
        </app-score-comparison-toggle>
    </div>
</div>

<div class="main-container" *ngIf="hasGroupSelection">
    <div class="lhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent === 'drillDownTable'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'drillDownTable'}">
                <div class="card">
                    <div class="card-filter">
                        <div>
                            <div class="card-name">Score</div>
                            <div class="ltms-description">{{ scoreDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <span class="viewByText">View by</span>
                            <app-score-dropdown-menu
                                [ngbTooltip]="viewTypeDropdown.config.isDisabled ? 'No cohorts configured.' : null"
                                [config]="viewTypeDropdown.config"
                                [selectedOption]="viewTypeDropdown.selectedOption"
                                [options]="viewTypeDropdown.options"
                                (selectedOptionChange)="onViewTypeChange($event)">
                            </app-score-dropdown-menu>
                            <app-score-widget
                                [fullScreenButtonControl]="isFullScreen"
                                [ngStyle]="{'margin-left': '12px'}"
                                [config]="scoreWidget('drilldown')"
                                (onFullscreenClick)="onFullScreen($event, 'drillDownTable')"
                                (onDownloadClick)="onDownload('drillDownTable')">
                            </app-score-widget>
                        </span>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="lhsBoxLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && lhsBoxError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <app-score-table
                        *ngIf="!lhsBoxLoader && !lhsBoxError"
                        [selectedRowHighlight]="true"
                        [selectedRowId]="textHighLightId"
                        [tableColumns]="scoreTable.header"
                        [tableData]="scoreTable.row"
                        [tablePlugins]="tablePlugins"
                        [showDeviation]="showComparisonFlag"
                        [deviationComparisonLabel]="comparisonPeriodLabel"
                        (onTextClickCall)="onTableRowClick($event)">
                    </app-score-table>
                    <!-- 2nd table (L1 questions) hidden for now
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && !lhsBoxError && cohortTableLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && !lhsBoxError && !cohortTableLoader && cohortTableError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <app-score-table
                        *ngIf="!lhsBoxLoader && !lhsBoxError && !cohortTableLoader && !cohortTableError && cohortTable.row.length"
                        [selectedRowHighlight]="true"
                        [selectedRowId]="textHighLightId"
                        [ngStyle]="{'margin-top': '12px'}"
                        [tableColumns]="cohortTable.header"
                        [tableData]="cohortTable.row"
                        [tablePlugins]="tablePlugins"
                        [showDeviation]="showComparisonFlag"
                        [deviationComparisonLabel]="comparisonPeriodLabel"
                        (onTextClickCall)="onTableRowClick($event)">
                    </app-score-table>
                    -->
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && !lhsBoxError && l2TableLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && !lhsBoxError && !l2TableLoader && l2TableError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <app-score-table
                        *ngIf="!lhsBoxLoader && !lhsBoxError && !l2TableLoader && !l2TableError && l2Table.row.length"
                        [selectedRowHighlight]="true"
                        [selectedRowId]="textHighLightId"
                        [ngStyle]="{'margin-top': '12px'}"
                        [tableColumns]="l2Table.header"
                        [tableData]="l2Table.row"
                        [tablePlugins]="tablePlugins"
                        [showDeviation]="showComparisonFlag"
                        [deviationComparisonLabel]="comparisonPeriodLabel"
                        (onTextClickCall)="onTableRowClick($event)">
                    </app-score-table>
                </div>
            </div>
        </div>
    </div>
    <div class="rhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent === 'lineChart'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'lineChart'}">
                <div class="card">
                    <div class="card-filter">
                        <div>
                            <div class="card-name">{{ lineChartDisplayName }} Trend • {{ chartName }}</div>
                            <div class="ltms-description">{{ scoreTrendsDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget
                                [fullScreenButtonControl]="isFullScreen"
                                [ngStyle]="{'margin-left': '12px'}"
                                [config]="scoreWidget('lineChart')"
                                (onFullscreenClick)="onFullScreen($event, 'lineChart')"
                                (onDownloadClick)="onDownload('lineChart')"
                                (onTrendClick)="onTrendChange($event, 'lineChart')">
                            </app-score-widget>
                        </span>
                    </div>
                    <div class="lineChartLoader" *ngIf="lineChartLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lineChartLoader" *ngIf="!lineChartLoader && lineChartError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <div class="chart" *ngIf="!lineChartLoader && !lineChartError">
                        <app-score-line-chart [chartPlugins]="lineChartPlugins" [chartData]="lineChartData"></app-score-line-chart>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="{'overlay': fullScreenComponent === 'barChart'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'barChart'}">
                <div class="card">
                    <div class="card-filter">
                        <div>
                            <div class="card-name">Response Trend • {{ chartName }}</div>
                            <div class="ltms-description">{{ responseTrendDescription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget
                                [fullScreenButtonControl]="isFullScreen"
                                [ngStyle]="{'margin-left': '12px'}"
                                [config]="scoreWidget('barChart')"
                                (onFullscreenClick)="onFullScreen($event, 'barChart')"
                                (onDownloadClick)="onDownload('barChart')"
                                (onTrendClick)="onTrendChange($event, 'barChart')"
                                (onChartTypeChange)="onBarChartTypeChange($event)">
                            </app-score-widget>
                        </span>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="barChartLoader" [ngStyle]="{'height': '255px'}">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="!barChartLoader && barChartError" [ngStyle]="{'height': '255px'}">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <div class="chart barGraph" *ngIf="!barChartLoader && !barChartError">
                        <app-score-bar-chart [chartPlugins]="barChartPlugins" [chartData]="barChartData"></app-score-bar-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
